const routes = {
  getUserProfile: 'user/profile',
  getUsers: 'user/'
};

export default routes